<script>
  export let answer;
  export let lastItem;
  export let onAnswer;
  export let selected;
</script>

<div
  class="formnumberrating w-button {lastItem ? 'lastitem' : ''} {selected ===
  answer.respuesta
    ? 'selected'
    : ''}"
  on:click={onAnswer}
>
  {answer.respuesta.split("-").length > 1 &&
  answer.respuesta.split("%").length === 1
    ? answer.respuesta.split("-")[0].trim()
    : answer.respuesta}
</div>

<style>
  div.selected {
    background-color: #36b499;
    font-weight: bold;
    color: white;
  }
</style>
